import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { environment } from '../../environments/environment';
import { EventEmitter } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-invoice-report',
  templateUrl: './invoice-report.component.html',
  styleUrls: ['./invoice-report.component.css']
})
export class InvoiceReportComponent implements OnInit {
  dataSource;
  displayedColumns = ['sno', 'service_category', 'actions'];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;



  @ViewChild('excel_table') table: ElementRef;

  @ViewChild('fileInput') fileInput;
  private appURL: string = environment.apiUrl;
  private uploadURL: string = environment.uploadUrl;
  public myFocusTriggeringEventEmitter = new EventEmitter<boolean>();
  myOptions: INgxMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 }
  };
  // Initialized to specific date (09.10.2018)
  model2: any = { date: { year: 2018, month: 10, day: 9 } };
  month1: any = {};
  wbetot_exp: any;
  mbetot_exp: any;
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {};
  cert: any = {};
  p: number = 1;
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  EMPS: any = [];
  totInvoice: any = 0;
  tip: any = 0;
  otherCharge: any = 0;
  g_pay: any = 0;
  wallet: any = 0;
  card: any = 0;
  cash: any = 0;
  cheque: any = 0;
  online_banking: any = 0;
  due: any = 0;
  salary: any = 0;
  isExpanded: boolean = false;
  isExpanded1: boolean = false;
  isExpanded2: boolean = false;
  isExpanded3: boolean = false;
  isExpanded4: boolean = false;
  isExpanded5: boolean = false;
  additionalcharge: any;
  cashRound: any;
  proFee: any;
  datass: any;
  usedWallet: any = 0;
  module_access: any;
  ViewInvoice: boolean = false;
  membershipInvoiceTotal: any;
  packageInvoiceTotal: any;
  membershipInvoice: any;
  packageInvoice: any;
  mem_cashTotal: number;
  mem_g_payTotal: number;
  mem_cardTotal: number;
  mem_salaryTotal: number;
  mem_online_bankingTotal: number;
  mem_dueTotal: number;
  mem_chequeTotal: number;
  pack_salaryTotal: number;
  pack_online_bankingTotal: number;
  pack_dueTotal: number;
  pack_chequeTotal: number;
  pack_cardTotal: number;
  pack_g_payTotal: number;
  pack_cashTotal: number;
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _flashMessagesService: FlashMessagesService

  ) {
  }

  covenants: any = [
    { provinceID: 1 },
    { provinceID: 2 },
    { provinceID: 3 },
    { provinceID: 4 },
    { provinceID: 5 },
  ];
  recordsperpage: number = 25;
  dataresult: any = [];

  openCoverages = false;
  indexSelectedCoverage = 1;

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
      if (JSON.parse(this.currentUser['module_access'])) {
        this.module_access = JSON.parse(this.currentUser['module_access'])
      } else {
        this.module_access = ''
      }
    } else {
      this.module_access = ''
    }
    this.ViewInvoice = this.checkModuleAcces('32');
    this.model['start_date'] = '';
    this.model['end_date'] = '';
    this.model['employee_id'] = '';
    this.model['bill_no'] = '';
    this.model['payMethod'] = '';
    this.model['mem_person'] = '';
    this.model['customer_name'] = '';
    this.model['phone'] = '';
    this.model['start_date'] = '';
    this.model['end_date'] = '';
    this.isExpanded = false;
    this.isExpanded1 = false;
    this.isExpanded2 = false;


    if (JSON.parse(JSON.parse(this.loginservice.getLocalSession('invoice_report_param'))) != null) {
      this.model = JSON.parse(JSON.parse(this.loginservice.getLocalSession('invoice_report_param')));
    } else {
      const now = new Date();
      // Start date: 1st of current month
      const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
      // End date: today
      const endDate = now;

      this.model.start_date = this.formatDateForPicker(startDate);
      this.model.end_date = this.formatDateForPicker(endDate);
      this.loginservice.setLocalSession(JSON.stringify(this.model), 'invoice_report_param');

    }

    this.loginservice.getemp('', this.currentUser).subscribe(
      data => {
        if (data['comp_details'].length > 0) {
          this.EMPS = data['comp_details'];
        } else {
          this.EMPS = [];
          // this.dataresult = [];
        }
      }, error => { alert('Network Error get emp API'); });
    this.getInvoiceReport();
    this.getPackageMembershipInvoiceReport();
    this.covenants.forEach((_covenants) => {
      _covenants.isExpanded = false;
    });
  }

  checkModuleAcces(module_id: string): boolean {
    if (!this.module_access) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_access)
      ? this.module_access
      : JSON.parse(this.module_access);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);
    if (mod) {
      // Set individual access flags
      return true; // module exists
    } else {
      // If not found, reset and return false
      return false;
    }
  }

  formatDateForPicker(dateObj: Date) {
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();

    return {
      date: { year: year, month: month, day: day },
      jsdate: dateObj.toISOString(),
      formatted: this.formatDDMMYYYY(day, month, year),
      epoc: Math.floor(dateObj.getTime() / 1000)
    };
  }

  formatDDMMYYYY(day: number, month: number, year: number): string {
    return this.pad(day) + '/' + this.pad(month) + '/' + year;
  }

  pad(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }

  changeRecordPerPage(value) {
    this.recordsperpage = value;
  }

  reset() {
    localStorage.removeItem('invoice_report_param');
    this.ngOnInit();
  }

  search() {
    this.loginservice.setLocalSession(JSON.stringify(this.model), 'invoice_report_param');
    this.getInvoiceReport();
    this.getPackageMembershipInvoiceReport();
  }

  onDateChanged(type, event: IMyDateModel): void {
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  getPackageMembershipInvoiceReport() {
    this.loginservice.getPackageMembershipInvoiceReport(this.model, this.currentUser)
      .subscribe((d: any) => {
        const mem = (d && d.membershipInvoiceTotal) ? d.membershipInvoiceTotal : {};
        const pack = (d && d.packageInvoiceTotal) ? d.packageInvoiceTotal : {};
        // Membership totals
        this.membershipInvoiceTotal = Number(mem.membershipInvoiceTotal || 0);
        this.mem_cashTotal = Number(mem.mem_cashTotal || 0);
        this.mem_g_payTotal = Number(mem.mem_g_payTotal || 0);
        this.mem_cardTotal = Number(mem.mem_cardTotal || 0);
        this.mem_chequeTotal = Number(mem.mem_chequeTotal || 0);
        this.mem_dueTotal = Number(mem.mem_dueTotal || 0);
        this.mem_online_bankingTotal = Number(mem.mem_online_bankingTotal || 0);
        this.mem_salaryTotal = Number(mem.mem_salaryTotal || 0);
        // Package totals
        this.packageInvoiceTotal = Number(pack.packageInvoiceTotal || 0);
        this.pack_cashTotal = Number(pack.pack_cashTotal || 0);
        this.pack_g_payTotal = Number(pack.pack_g_payTotal || 0);
        this.pack_cardTotal = Number(pack.pack_cardTotal || 0);
        this.pack_chequeTotal = Number(pack.pack_chequeTotal || 0);
        this.pack_dueTotal = Number(pack.pack_dueTotal || 0);
        this.pack_online_bankingTotal = Number(pack.pack_online_bankingTotal || 0);
        this.pack_salaryTotal = Number(pack.pack_salaryTotal || 0);
        this.membershipInvoice = (d && d.membershipInvoice) ? d.membershipInvoice : [];
        this.packageInvoice = (d && d.packageInvoice) ? d.packageInvoice : [];
      }, error => { alert('Network Error getPackageMembershipInvoiceReport API'); });
  }




  getInvoiceReport() {
    this.showLoader = true;
    this.loginservice.getInvoiceReport(this.model, this.currentUser)
      .subscribe(
        data => {
          if (data['comp_details'].length > 0) {
            this.dataresult = data['comp_details'];
            this.totInvoice = data['totInvoice'];
            this.tip = data['tip'];
            this.otherCharge = data['otherCharge'];
            this.usedWallet = data['usedWallet'];
            this.additionalcharge = data['additionalcharge'];
            this.cashRound = data['cashRound'];
            this.proFee = data['proFee'];
            this.cash = data['cash'];
            this.card = data['card'];
            this.g_pay = data['g_pay'];
            this.wallet = data['wallet'];
            this.cheque = data['cheque'];
            this.due = data['due'];
            this.online_banking = data['online_banking'];
            this.salary = data['salary'];
            this.certificate = data;
            this.showLoader = false;
            let tableArr: Element[] = data['comp_details'];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          } else {
            this.dataresult.length = 0;
            this.totInvoice = 0;
            this.tip = 0;
            this.otherCharge = 0;
            this.additionalcharge = 0;
            this.cashRound = 0;
            this.proFee = 0;
            this.cash = 0;
            this.card = 0;
            this.g_pay = 0;
            this.wallet = 0;
            this.cheque = 0;
            this.due = 0;
            this.online_banking = 0;
            this.salary = 0;
            // this._flashMessagesService.show('No Subcontractors!', { cssClass: 'alert-danger' });
            // this.router.navigate(['addlowertier']);
            this.showLoader = false;
            let tableArr: Element[] = [];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          }
        },
        error => {
          alert('Network Error getInvoiceReport API');
          this.showLoader = false;
        });
  }

  printBill(bill_no, customer_id) {
    this.loginservice.printBill(bill_no, customer_id, this.currentUser)
      .subscribe(
        data => {
          if (data) {
            this.router.navigate(['print-preview'], {
              queryParams: {
                tot_amt: JSON.stringify(data['tot_amt']),
                invoiceTotal: JSON.stringify(data['invoiceTotal']),
                model: JSON.stringify(data['model']),
                multiple_offer: JSON.stringify(data['multiple_offer']),
                chekoutArray: JSON.stringify(data['chekoutArray']),
                product_multiple_offer: JSON.stringify(data['product_multiple_offer']),
                productsTobuy: JSON.stringify(data['productsTobuy']),
                discount: JSON.stringify(data['discount']),
                bill_no: JSON.stringify(data['bill_no']),
                add_charge: JSON.stringify(data['add_charge']),
                billed_on: JSON.stringify(data['billed_on']),
                from: JSON.stringify('invoiceReport'),
              }
            });
          }
        }, error => { alert('Network Error printBill API'); });
  }

  exportAsExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);//converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, 'Invoice Report.xlsx');
  }

  public mprint() {
    window.print();
  }

  tableToExcel(table, excelName) {
    let list: any = [];
    var exports1 = [];
    this.datass = this.dataresult;
    exports1 = this.dataresult;
    let sno = 1; // Initialize serial number
    exports1.forEach(element => {
      element.service_list = ''; // Initialize service_list as an empty string
      element.billed_on = element.billed_on.substring(0, 10);
      // Collect all service descriptions in an array
      let services = element.bill.map(elementss => elementss.service_desc);

      // Join the services with commas and assign it to service_list
      element.service_list = services.join(', ');

      sno = sno + 1; // Increment the serial number
      list.push({ '#': sno, 'Date': element.billed_on, 'Customer Name': element.customer_name, 'Phone': element.phone, 'How do You Know about this Place': element.how, 'Services': element.service_list.trim() }); // Trim the trailing comma and space
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(list);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    XLSX.writeFile(workbook, excelName + '.xls', { bookType: 'xls', type: 'buffer' });
  }

  convertNumber(value: any): number {
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  }

  roundGst(value) {
    return Math.round(value);
  }

  deleteInvoice(bill_no, currentUser) {
    if (confirm("Are you sure to delete bill " + bill_no)) {
      if (confirm("Once Deleted Cant't Able To Restore. So Are You Sure?")) {
        this.loginservice.deleteInvoice(bill_no, currentUser).subscribe(data => {
          if (data['status'] === 'success') {
            this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
            alert(data['message']);
            this.currentUser.credits = data['credit'];
            this.loginservice.setLocalSession(this.currentUser, 'currentUser');
            this.search();
          }
        });
      }
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/invoice-report/invoice-report.component.ts